import {BON_PLAN_ROUTES as bonPlanRoutes} from "~/api/routes";
import {generateOptions} from "~/helpers";
export const state = () => ({
  bonPlans: [],
  details: null,
  image: null,
  close:false,
  isRequesting:false
});

export const getters = {
  optionsBonplan: (state) => (category=null) =>{
    try {
      if (state.bonPlans)
        if(!category)
          return generateOptions(state.bonPlans);
        else
          return generateOptions(state.bonPlans.filter(elem=>{
            if(category !== -1){
              return elem.categories ? elem.categories.filter(unit => unit.categorie_id === category).length === 0 : false
            }
            return true;
          }));
    } catch (e) {
    }
  },
  getAttachedBonplan: (state, getters) => (category) => {
    try {
      const options = getters.optionsBonplan(category);
      if (state.bonPlans)
        return  generateOptions(state.bonPlans.filter(elem=>
          (options.filter(y => {
            return y.item.article_id === elem.article_id
          })).length === 0
        ))
    } catch (e) {
    }
  },
};

export const mutations = {
  BONPLANS_LOAD(state) {
    //state.isLoading = true;
    state.hasError = false;
    state.bonPlans = [];
    //state.page = page;
  },
  CLOSE_MODAL(state,close){
    state.close = close;
  },
  BONPLANS_SUCCES(state, bonPlans) {
    bonPlans.forEach((details) => {
      try{
        // details['date_expiration'] = details['date_expiration'] ? details['date_expiration'].slice(0, -9) : null;
        if (!details['qte']) details['qte'] = 1;
        if (!details['type_reduction']) details['type_reduction'] = 'unit';
        // details['date_debut']=details['date_debut'] ? details['date_debut'].slice(0,-9) : null;
        // details['date_fin']= details['date_fin'] ? details['date_fin'].slice(0,-9) : null;
      }catch(e){
      }
    });
    state.bonPlans = bonPlans;
    //state.pagination = params.payload.pagination;
    //state.filters = params.filters || state.filters;
  },
  BONPLANS_ERROR(state) {
    state.bonPlans = [];
    state.hasError = true;
  },
  BONPLANS_LOADED(state) {
    //state.isLoading = false;
  },
  BONPLAN_PROCESSING_START(state) {
    //state.isLoading = false;
  },
  BONPLAN_PROCESSING_END(state) {
    //state.isLoading = false;
  },
  BONPLAN_SUCCES(state) {
    //state.isLoading = false;
  },
  BONPLAN_ERROR(state) {
    //state.isLoading = false;
  },
  UPDATE_A_BONPLAN(state, bonplan) {
    try{
      let index = state.bonPlans.findIndex((elem) => elem.article_id === bonplan.article_id);
      state.bonPlans = state.bonPlans.filter(element => element.article_id !== bonplan.article_id);
      // bonplan['date_debut']=bonplan['date_debut'] ? bonplan['date_debut'].slice(0,-9) : null;
      // bonplan['date_fin']=bonplan['date_fin'] ? bonplan['date_fin'].slice(0,-9) : null;
      // bonplan['date_expiration']=bonplan['date_expiration'] ? bonplan['date_expiration'].slice(0,-9) : null;
      state.bonPlans.splice(index, 0, bonplan);
    }catch(e){
    }

  },
  ADD_BONPLAN_TO_LIST(state, bonplan) {
    state.bonPlans.unshift(bonplan);
  },
  SET_BONPLAN_IMAGE(state, image) {
    state.image = image;
  },
  REMOVE_BONPLAN_FROM_LIST(state, bonplan) {
    state.bonPlans = state.bonPlans.filter(element => element.article_id !== bonplan.article_id);
  },
  GET_BONPLAN_SUCCES(state, details) {
    try{
      // details['date_debut']=details['date_debut'] ? details['date_debut'].slice(0,-9) : null;
      // details['date_fin']=details['date_fin'] ? details['date_fin'].slice(0,-9) : null;
      // details['date_expiration']= details['date_expiration'] ? details['date_expiration'].slice(0,-9) : null;
      state.details = details
      //state.isLoading = false;
    }catch(e){
    }

  },
  REMOVE_BONPLAN_IMAGE(state, article_id) {
    let index = state.bonPlans.findIndex((elem) => elem.article_id === article_id);
    state.bonPlans[index].image=null;
  },
  IS_REQUESTING(state,isRequesting){
    state.isRequesting = isRequesting
  }
};

export const actions = {
  async getBonplans({commit}) {
    commit('BONPLANS_LOAD');
    commit('IS_REQUESTING',true);
    this.$api.request(bonPlanRoutes.list)
      .then(response => {
        commit('BONPLANS_SUCCES', response.payload);
      })
      .catch(error => {
        commit('BONPLANS_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('BONPLANS_LOADED')
      });
  },

  async attachItems({commit}, params) {
    // if(params.items.length>0){
      commit('BONPLAN_PROCESSING_START');
      await this.$api.request(bonPlanRoutes.items.attach, {id: params.id}, params.items)
        .then(response => {
          //commit('PACK_SUCCES', response);
          commit('UPDATE_A_BONPLAN', response.payload);
        })
        .catch(error => {
          commit('BONPLAN_ERROR');
        })
        .finally(() => commit('BONPLAN_PROCESSING_END'));
    // }
  },
  async detachItems({commit}, params) {
    commit('BONPLAN_PROCESSING_START');
    await this.$api.request(bonPlanRoutes.items.detach, {id: params.id}, params.items.secondRequest)
      .then(response => {
        //commit('', response);
        this.dispatch('bonPlan/attachItems',{items:params.items.firstRequest,id:params.id});
      })
      .catch(error => {
        commit('BONPLAN_ERROR');
      })
      .finally(() => commit('BONPLAN_PROCESSING_END'));
  },

  async getBonplan({commit}, params) {
    commit('BONPLAN_PROCESSING_START');
    await this.$api.request(bonPlanRoutes.get, {id: params.article_id})
      .then(response => {
        commit('GET_BONPLAN_SUCCES', response.payload);
      })
      .catch(error => {
        commit('BONPLAN_ERROR');
      })
      .finally(() => commit('BONPLAN_PROCESSING_END'));
  },

  async createBonplan({commit}, params) {
    commit('BONPLAN_PROCESSING_START');
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(bonPlanRoutes.create, {}, params.formData)
      .then(response => {
        commit('CLOSE_MODAL',true);
        commit('ADD_BONPLAN_TO_LIST', response.payload);
        const data = params.nextRequest.firstRequest;
        if(data && data.length>0)
        this.dispatch('bonPlan/attachItems',{items:data,id:response.payload.article_id})
      })
      .catch(error => {
        commit('CLOSE_MODAL',false);
        commit('BONPLAN_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('BONPLAN_PROCESSING_END')
      });
  },
  async updateBonplan({commit}, params) {
    commit('BONPLAN_PROCESSING_START');
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(bonPlanRoutes.update, {id: params.id}, params.formData)
      .then(response => {
        //commit('BONPLAN_SUCCES', response);
        commit('UPDATE_A_BONPLAN', response.payload);
        commit('CLOSE_MODAL',true);
        if(params.nextRequest.secondRequest){
          this.dispatch('bonPlan/detachItems',{items:params.nextRequest,id:params.id});
        }else{
          const data = params.nextRequest.firstRequest;
          if(data && data.length>0)
          this.dispatch('bonPlan/attachItems',{items:data,id:params.id});
        }
      })
      .catch(error => {
        commit('CLOSE_MODAL',false);
        commit('BONPLAN_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('BONPLAN_PROCESSING_END')
      });
  },
  async deleteBonplan({commit}, params) {
    commit('BONPLAN_PROCESSING_START');
    await this.$api.request(bonPlanRoutes.delete, {id: params.article_id})
      .then(response => {
        commit('REMOVE_BONPLAN_FROM_LIST', response.payload);
      })
      .catch(error => {
        commit('BONPLAN_ERROR');
      })
      .finally(() => commit('BONPLAN_PROCESSING_END'));
  },
  async removeImage({ commit }, params){
    commit('REMOVE_BONPLAN_IMAGE', params.id);
  }
};
